// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".strobee[data-v-937bb61a]{position:absolute;top:0;left:0;z-index:999;width:100%;--tw-translate-y:-120px;transform:var(--tw-transform);background-color:transparent;height:calc(100% + 120px);animation:strobe-937bb61a 1s infinite}@keyframes strobe-937bb61a{90%{background:transparent}to{background:#fff}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
